import React, { useEffect } from "react"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { BiBriefcase, BiMap, BiInfoCircle } from "react-icons/bi";

const motionSection = {
  hidden: {
    opacity: 0,
    // y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.16, 1, 0.3, 1],
      // when: "beforeChildren",
    },
  },
}
const motionItems = {
  hidden: {
    opacity: 0,
    y: 20,
    // rotate: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 1,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const desc = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}

const JobListing = ({ block }) => {
  const data = useStaticQuery(graphql`
    query jobListingQuery {
      careers: allSanityCareers {
        nodes {
          title
          slug {
            current
          }
          jobType
          jobLocation
          jobPay
        }
      }
    }
  `)

  const { heading, text } = block
  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  return (
    <motion.section
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
      className="section multicolumn"
    >
      {heading && (
        <div className="module-image-text-carousel__content flex flex-col justify-center mb-8 items-center text-center container max-w-screen-md">
          <h2 className="w-fit h2 mb-6 relative">
            <motion.div variants={title}>{heading}</motion.div>
            <motion.div
              variants={underline}
              className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0"
            />
          </h2>
          <motion.p variants={desc}>{text}</motion.p>
        </div>
      )}

      <div className="container">
        <motion.div variants={desc} className="mt-8">
          <div className="grid lg:grid-cols-3 gap-5">
            {data.careers.nodes.map((item, index) => {
              // console.log("item", item)
              return (
                <Link
                  to={item.slug.current}
                  className="block p-4 rounded-lg shadow-sm shadow-orange-100 bg-white"
                >
 

                    <div className="">
                      <dl>

                        <div>
                          <dt className="sr-only">Job title</dt>

                          <dd className="font-medium text-lg">
                            {item.title}
                          </dd>
                        </div>
                      </dl>

                      <dl className="flex items-center mt-4 space-x-8 text-xs">
                        <div className="sm:inline-flex sm:items-center sm:shrink-0">
                          <BiBriefcase fill="orange" className="h-4 w-4"/>

                          <div className="sm:ml-3 mt-1.5 sm:mt-0">
                            <dd className="text-xs">{item.jobType}</dd>
                          </div>
                        </div>

                        <div className="sm:inline-flex sm:items-center sm:shrink-0">
                        <BiMap fill="orange" className="h-4 w-4"/>

                        <div className="sm:ml-3 mt-1.5 sm:mt-0">
                          <dd className="text-xs">{item.jobLocation}</dd>
                        </div>
                        </div>

                          <div className="sm:inline-flex sm:items-center sm:shrink-0">
                          <BiInfoCircle fill="orange" className="h-4 w-4"/>

                          <div className="sm:ml-3 mt-1.5 sm:mt-0">
                            <dd className="text-xs">{item.jobPay}</dd>
                          </div>
                        </div>
                      </dl>

                      <p className="relative inline-block mt-6 text-sm font-bold text-orange-500">
                        <span className="absolute inset-x-0 bottom-0 transition-transform transform bg-orange-100 h-2/3 hover:scale-110"></span>
                        <span className="relative">Apply</span>
                      </p>
                    </div>
                </Link>
              )
            })}
          </div>
        </motion.div>
      </div>
    </motion.section>
  )
}

export default JobListing
